import { request, query } from '@/utils/request';
import { stringify } from 'qs';

const urls = {
  orderList: '/zlb/api/travel/operator/order/list', // 获取差旅订单列表接口
  tripOrderDetail: '/zlb/api/travel/operator/order/detail' // 获取订单详情接口
};
export function tripOrderDetail (payload) {
  return request(`${urls.tripOrderDetail}?${stringify(payload)}`);
}

export async function getOrderList (data) {
  return request(urls.orderList, { method: 'POST', data });
}

// 导出订单开票信息
export async function exportInvoice (data) {
  return request('/zlb/api/travel/invoice/export', {
    method: 'post',
    data,
    responseType: 'blob',
  });
}

// 接excel导出任务
export const exportTravelExcel = async (data) => {
  return query('/zlb/api/travel/export/travel-export', {
    data,
    method: 'POST',
  });
};

// 查询Excel导出结果
export async function queryTravelExportTask (params) {
  return request(`/zlb/api/travel/export/query-travel-result/${params.taskSerialCode}`);
}
